<!--
 * @Description: 子经销商
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-24 10:17:45
 * @LastEditTime: 2021-12-02 14:42:12
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 子经销商 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options"></echarts>
        <img class="icon" src="../../assets/img/bigScreen/distributor.png" alt="">
      </div>
      <div class="chart-lengend">
        <div v-for="(item, i) in list" :key="i" class="item">
          <p>
            <i :style="{backgroundColor: item.color}"></i>
            {{item.name}}
          </p>
          <p class="legend-value" :style="{color: item.color}">
            <span>{{item.rate}}%</span>
            <span :title="item.num">{{item.num}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      list: [
        { name: '一级经销商', color: '#1072FD', num: '0', rate: '0' },
        { name: '二级经销商', color: '#06BF73', num: '0', rate: '0' },
        { name: '其他', color: '#7670FC', num: '0', rate: '0' }
      ],
      options: {
        series: [
          {
            name: '一级经销商',
            type: 'pie',
            radius: ['80%', '85%'],
            emphasis: { scale: false },
            labelLine: { show: false },
            data: [
              { value: 0, name: '', itemStyle: { color: '#1072FD' } },
              { value: 100, name: '', itemStyle: { color: '#173657' } }
            ]
          },
          {
            name: '二级经销商',
            type: 'pie',
            radius: ['70%', '75%'],
            emphasis: { scale: false },
            labelLine: { show: false },
            data: [
              { value: 0, name: '', itemStyle: { color: '#06BF73' } },
              { value: 100, name: '', itemStyle: { color: '#173657' } }
            ]
          },
          {
            name: '其他',
            type: 'pie',
            radius: ['60%', '65%'],
            emphasis: { scale: false },
            labelLine: { show: false },
            data: [
              { value: 0, name: '', itemStyle: { color: '#7670FC' } },
              { value: 100, name: '', itemStyle: { color: '#173657' } }
            ]
          },
        ]
      }
    }
  },
  created() {
    this.getEchartsData()
  },
  mounted() {},
  computed: {
    idName() {
      return this.flag ? "echartsId7_big" : "echartsId7"
    },
    styleObj() {
      return this.flag ? {
        fontSize: 30,
        barWidth: 50,
        barBorderRadius: 20
      } : {
        fontSize: 16,
        barWidth: 20,
        barBorderRadius: 5
      }
    }
  },
  methods: {
    async getEchartsData () {
      let { code, msg, data } = await this.request.get('/front/system/tenant/statistics')
      let options = JSON.parse(JSON.stringify(this.options))
      let list = JSON.parse(JSON.stringify(this.list))

      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      if (data == null || data.length < 1) {
        
        return
      }

      // 按照之前的逻辑，取三个数的最大值为满值
      var max = Math.max.apply(null, data)

      data.forEach((num, i) => {
        // 计算各个数值占最大值的比
        let rate = Math.trunc(num * 100 / max)

        options.series[i].data[0].value = rate
        options.series[i].data[1].value = 100 - rate

        list[i].num = num
        list[i].rate = rate
      })

      this.options = options
      this.list = list
    }
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        position: relative;
        display: inline-block;
        width: 48%;
        height: 100%;
        vertical-align: top;
        .icon {
          position: absolute;
          top: 35%;
          left: 35%;
          width: 30%;
          height: 30%;
          // width: 46px;
          // height: 46px;
          // margin-top: -23px;
          // margin-left: -23px;
        }
      }
      .chart-lengend {
        display: inline-block;
        width: 50%;
        color: #fff;
        font-size: 14px;
        text-align: left;
        margin-top: 15px;
        .item {
          margin: 6px 10px;
          .legend-value {
            font-size: 16px;
            span {
              display: inline-block;
              width: 36%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-left: 10px;
              &:last-child {
                margin-left: 18px;
              }
            }
          }
          i {
            display: inline-block;
            width: 8px;
            height: 8px;
            background-color: #ccc;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
